import { CustomEvent } from './CustomEvent';
export class LogEvent extends CustomEvent {
    constructor(data) {
        super('log', {
            detail: data,
        });
    }
}
//# sourceMappingURL=LogEvent.js.map